<div *ngIf="modo==='normal'">
  <header class="promo-hero">
    <div class="hero-content">
      <div class="ico">
        <i class="mdi mdi-label-percent-outline"></i>
      </div>
      <div class="text-group">
        <h1 class="label">Ofertas y promociones</h1>
        <p class="subtitle">Descubrí los mejores precios y beneficios exclusivos para vos.</p>
      </div>
    </div>
  </header>
  <section class="margensection">
    <div *ngIf='!ocultarPrecios' class="containermainprod">
      <mmax-landpage-frame class="promo-section-title" [nombre]="'PROMOCIONES'"
        [ngStyle]="{display: promosDisplay}">
      </mmax-landpage-frame>
      <!-- Promociones -->
      <div class="displayPromos">
        <div *ngFor="let promo of promos" style="width: fit-content;">
          <promocion-card *ngIf="promo.getPromocionValida()" [promocion]="promo"></promocion-card>
        </div>
      </div>
      <mmax-landpage-frame class="promo-section-title" [nombre]="'Ofertas del mes'"
        [ngStyle]="{display: ofertasDisplay}">
      </mmax-landpage-frame>
      <!-- Ofertas -->
      <lista-productos-view [articulosIn]="ofertas" [modelo]="'oferta'"></lista-productos-view>
    </div>
  </section>
</div>
<mmax-helpfootbar></mmax-helpfootbar>

<foo-mariano-max></foo-mariano-max>